import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43e04f81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-line" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("插入")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_explorer = _resolveComponent("file-explorer")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.prompted,
    "custom-class": "the-file-dialog",
    title: "选择文件",
    onClosed: _ctx.onClosed,
    draggable: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_file_explorer, {
        selectedItemPath: _ctx.selectedItemPath,
        "onUpdate:selectedItemPath": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItemPath) = $event)),
        editable: false,
        extension: _ctx.extension
      }, null, 8, ["selectedItemPath", "extension"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          disabled: _ctx.selectedItemPath === null,
          onClick: _ctx.onCommit,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
}